import slugify from 'slugify';
import { getId } from './brandDiffsUtils';
const imageutils = {
    // res: {
    //   HIRES: { width: 1571, height: 2000 },
    //   LG: { width: 1024, height: 1304 },
    //   MD: { width: 768, height: 977 },
    //   SM: { width: 360, height: 458 },
    //   XS: { width: 73, height: 93 },
    //   XXS: { width: 15, height: 19 },
    // },
    transform: function (url, size, alt, quality, format) {
        var _a, _b;
        if (!url) {
            return url;
        }
        if (url.indexOf('thron') > -1) {
            let name = alt ? slugify(alt, { remove: /[*+~.()'"!:@/]/g, lower: true }) : 'image';
            let fullurl = ((_a = url.split('image/')) === null || _a === void 0 ? void 0 : _a[0]) + 'image/' + name + '.jpg';
            let params = [];
            if ((url === null || url === void 0 ? void 0 : url.indexOf('0x0')) === -1) {
                //NEXT
                fullurl = ((_b = url.split('image/')) === null || _b === void 0 ? void 0 : _b[0]) + 'image/' + name + '.jpg';
                if (size.width) {
                    params.push(['w', size.width]);
                }
                params.push(['q', quality !== null && quality !== void 0 ? quality : 80]);
            }
            else {
                //UAN - PILOT
                fullurl = url.replace(/\/0x0\/.*/, `/${size.width}x${size.height}/${name}.jpg`);
                params.push(['scalemode', 'centered']);
                params.push(['adjustcrop', 'reduce']);
                const imgQuality = quality || 80;
                if (imgQuality > 0) {
                    params.push(['quality', imgQuality]);
                }
                if (format === 'avif') {
                    params.push(['format', 'avif']);
                }
                else {
                    params.push(['format', 'WEBP']);
                }
            }
            if (params.length > 0) {
                fullurl = fullurl + '?' + params.map((i) => i[0] + '=' + i[1]).join('&');
            }
            return fullurl;
        }
        if (url.includes('fluidconfigure')) {
            return `${url}?width=${size.width}&height=${size.height}`;
        }
        return `${url}?sw=${size.width}&sh=${size.height}`;
    },
    hires: function (url, alt) {
        return this.transform(url, HIRES, alt);
    },
    large: function (url, alt) {
        return this.transform(url, LG, alt);
    },
    medium: function (url, alt) {
        return this.transform(url, MD, alt);
    },
    small: function (url, alt) {
        return this.transform(url, SM, alt);
    },
    extraSmall: function (url, alt) {
        return this.transform(url, XS, alt);
    },
};
export default imageutils;
// let aspectratio = 2000 / 1571; // oldimages
let aspectratio = {
    MO: 2880 / 1920,
    ST: 2880 / 2160,
};
const size = (width) => {
    return {
        width: width,
        height: Math.round(width * aspectratio[getId()]),
    };
};
export const HIRES = size(1571);
export const LG = size(1024);
export const MD = size(768);
export const SM = size(360);
export const XS = size(73);
export const XXS = size(30); // servirà per il lazyloading
